import { FormattedMessage } from 'react-intl';

import { SignDocumentStep } from '../../SignDocumentStep/SignDocumentStep';

export const SignCreditAgreement = () => {
    return (
        <SignDocumentStep
            title={
                <FormattedMessage
                    id="_.funding_requirements.credit_agreement_step.title"
                    defaultMessage="Sign Credit Agreement"
                />
            }
            subtitle={
                <FormattedMessage
                    id="_.funding_requirements.credit_agreement_step.subtitle"
                    defaultMessage="Please read the entire agreement and click 'Sign Credit Agreement' to continue."
                />
            }
            buttonLabel={
                <FormattedMessage
                    id="_.funding_requirements.credit_agreement_step.sign_button"
                    defaultMessage="Sign credit agreement"
                />
            }
            type="master_loan_agreement"
            requirementType="CREDIT_AGREEMENT"
        />
    );
};
